/* ============================================================================
 * DUENDE — Shopify dynamic-checkout "Buy it now" styler
 *
 * The unbranded Buy-it-now button is rendered by Shopify at runtime
 * (`{{ form | payment_button }}` -> dynamic module). Shopify injects its
 * own stylesheet with rules of the form `.shopify-payment-button__button {
 * ... }` AFTER theme CSS, which can out-cascade theme rules — even with
 * !important on the theme side, source-order ties can lose. Some renders
 * wrap the button inside `<shopify-cleanslate>` which deliberately resets
 * inherited properties.
 *
 * To guarantee parity with ADD TO CART regardless of how Shopify renders
 * the button, this module applies INLINE styles + uppercases the text
 * directly on every matching node. Inline-style + !important is the
 * highest priority a non-shadow rule can reach.
 *
 * Re-runs on:
 *   - initial load (DOMContentLoaded)
 *   - Shopify's late hydration (MutationObserver)
 *   - font load (text width changes once Adobe Fonts swaps)
 * ============================================================================ */

(function () {
  if (window.__duendePaymentButtonStyler) return;
  window.__duendePaymentButtonStyler = true;

  var INLINE_STYLE = [
    'font-size: 1.2rem !important',
    'font-weight: 700 !important',
    'line-height: 1.5 !important',
    'letter-spacing: 0 !important',
    'text-transform: uppercase !important',
    'padding: 1.2rem 2rem !important',
    'min-height: 4.2rem !important',
    'border-radius: 5rem !important',
    'font-family: var(--font-heading-family) !important'
  ].join(';') + ';';

  function uppercaseTextNodes(root) {
    var walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );
    var node;
    while ((node = walker.nextNode())) {
      var raw = node.nodeValue;
      if (!raw) continue;
      var trimmed = raw.trim();
      if (!trimmed) continue;
      var up = trimmed.toUpperCase();
      if (up === trimmed) continue;
      node.nodeValue = raw.replace(trimmed, up);
    }
  }

  function styleNode(node) {
    if (!node || node.nodeType !== 1) return;
    var prev = node.getAttribute('style') || '';
    // avoid stacking duplicates if called repeatedly
    if (prev.indexOf('font-size: 1.2rem !important') !== -1) {
      uppercaseTextNodes(node);
      return;
    }
    node.setAttribute('style', prev + (prev && !/;$/.test(prev) ? ';' : '') + INLINE_STYLE);
    uppercaseTextNodes(node);
  }

  function styleAll(root) {
    (root || document).querySelectorAll([
      'button.shopify-payment-button__button',
      'button.shopify-payment-button__button--unbranded',
      '.shopify-payment-button [role="button"]',
      '.shopify-payment-button button',
      'shopify-cleanslate button',
      'shopify-cleanslate [role="button"]'
    ].join(',')).forEach(styleNode);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { styleAll(); });
  } else {
    styleAll();
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { styleAll(); });
  }

  // Shopify renders the button asynchronously — observe DOM additions.
  var observer = new MutationObserver(function (mutations) {
    var hit = false;
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (
          n.classList && (
            n.classList.contains('shopify-payment-button__button') ||
            n.classList.contains('shopify-payment-button')
          )
        ) hit = true;
        if (
          n.querySelector && n.querySelector(
            'button.shopify-payment-button__button, .shopify-payment-button [role="button"], shopify-cleanslate button, shopify-cleanslate [role="button"]'
          )
        ) hit = true;
        if (n.tagName === 'SHOPIFY-CLEANSLATE') hit = true;
      });
    });
    if (hit) styleAll();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
